var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "login-main-mobile"
  }, [_c('Form', {
    ref: "form",
    attrs: {
      "model": _vm.login.formData,
      "label-position": "top"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": $t("ewbd43", "手机号")
    }
  }, [_c('CountryCode', {
    ref: "countryCode",
    staticClass: "country_code",
    attrs: {
      "required-message": $t("shk6ya5", "手机号必填")
    },
    on: {
      "on-enter": _vm.handleContinue
    },
    model: {
      value: _vm.login.formData,
      callback: function ($$v) {
        _vm.$set(_vm.login, "formData", $$v);
      },
      expression: "login.formData"
    }
  })], 1), _c('LoginPasswordType', {
    ref: "loginPasswordTypeMobile",
    attrs: {
      "data": _vm.passwordType,
      "password-required-message": $t("c2r1q94", "密码必填")
    },
    on: {
      "on-change": _vm.onChange,
      "on-send-verify": _vm.handleSuccessVerify,
      "on-enter": _vm.handleContinue
    }
  }), _c('Agreenment', {
    staticClass: "agreenment",
    model: {
      value: _vm.login.loginAgreement,
      callback: function ($$v) {
        _vm.$set(_vm.login, "loginAgreement", $$v);
      },
      expression: "login.loginAgreement"
    }
  }), _c('Button', {
    staticClass: "continue-btn",
    attrs: {
      "type": "primary",
      "long": ""
    },
    on: {
      "click": _vm.handleContinue
    }
  }, [_vm._v(` ${$t("ma5i2", "继续")} `), _c('Icon', {
    staticClass: "continue-icon",
    attrs: {
      "type": "md-arrow-forward"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };